import { Reveal, SectionTag } from "./shared";

const CASES = [
  {
    img: "/assets/pexels-keyboard.jpg",
    alt: "Mechanical keyboard on a dark desk",
    title: "Keyboards & PCs",
    desc: "Blast crumbs and dust from between switches. Drop to gear 1 for delicate fans.",
    span: "lg:col-span-5",
    h: "h-[300px] md:h-[420px]",
  },
  {
    img: "/assets/pexels-car.jpg",
    alt: "Sports car covered in wash foam",
    title: "Car Detailing",
    desc: "Chase water out of mirrors, grilles and badges. Dry an engine bay in minutes.",
    span: "lg:col-span-7",
    h: "h-[300px] md:h-[420px]",
  },
  {
    img: "/assets/pexels-camera.jpg",
    alt: "Hands cleaning a camera lens",
    title: "Camera Gear",
    desc: "Contactless dust removal for bodies and lenses — no brushes touching glass.",
    span: "lg:col-span-7",
    h: "h-[300px] md:h-[380px]",
  },
  {
    img: "/assets/x8-3.jpg",
    alt: "X8 Violent Fan held in hand with display lit",
    title: "Everyday Carry",
    desc: "Campfires, BBQs, snow off boots, inflating pool toys. It lives in your bag.",
    span: "lg:col-span-5",
    h: "h-[300px] md:h-[380px]",
  },
];

export const UseCases = () => (
  <section id="missions" data-testid="use-cases-section" className="border-t border-steel bg-carbon/40">
    <div className="mx-auto max-w-[1600px] px-5 py-24 md:px-10 md:py-36">
      <Reveal>
        <SectionTag index="05" label="Field Missions" />
        <div className="mt-6 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <h2 className="max-w-3xl font-display text-3xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
            One tool.<br /><span className="text-outline">Every mission.</span>
          </h2>
          <p className="max-w-sm text-sm leading-relaxed text-smoke md:text-base">
            From desk setups to driveways — wherever dust, water or snow is losing the fight.
          </p>
        </div>
      </Reveal>
      <div className="mt-14 grid gap-4 md:mt-20 lg:grid-cols-12">
        {CASES.map((c, i) => (
          <Reveal key={c.title} delay={0.08 * i} className={c.span}>
            <figure
              data-testid={`use-case-${i}`}
              className="group relative overflow-hidden border border-steel"
            >
              <img
                src={c.img}
                alt={c.alt}
                loading="lazy"
                className={`${c.h} w-full object-cover grayscale-[40%] transition-[transform,filter] duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0`}
              />
              <figcaption className="absolute inset-x-0 bottom-0 border-t border-white/10 bg-ink/70 p-5 backdrop-blur-md">
                <div className="flex items-center justify-between">
                  <span className="font-display text-sm font-bold uppercase tracking-wide">{c.title}</span>
                  <span className="font-mono text-[10px] tracking-[0.3em] text-volt">0{i + 1}</span>
                </div>
                <p className="mt-2 text-xs leading-relaxed text-smoke md:text-sm">{c.desc}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
